import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_29 implements Validator {

    public static id = 'CTRL_29';
    private message = 'error.ctr_29';


    public LOG: LogService = new LogService(CTRL_29);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_29.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const critere = ctrl.value.rgCtrls.critere;

                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                
                const controlsName = [];
                const critereIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepAtt_critere'], 'SepSep_CriterePondere_SepAtt_critere');


				            for (let i = 1; i <= critereIters.size; i++) {
								controlsName.push(critere.replace('INDEX_29_1', i));
							}
				            const valuesCritere: boolean[] = [];
				            for (let i = 0; i < controlsName.length; i++) {
					valuesCritere.push(form.controls[map.get(controlsName[i])].value.length > 2);
				}
                if (valuesCritere.indexOf(false) !== -1) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
            }
        }
    }
}
